/*
 * @Description: 营销活动详情页面接口
 * @Author: kayvor
 * @Date: 2020-08-20 09:14:11
 * @LastEditors: kayvor
 * @LastEditTime: 2021-04-26 17:49:59
 */

import ajax from '../http/ajax'

// 获取营销活动详情数据
export const getMarketingActivities = params => {
    return ajax.get('getMarketingActivities', params)
}

// 获取营销活动详情优惠券列表数据
export const getCouponList = params => {
    return ajax.get('getCouponList', params)
}

// 立即抢购
export const createOrder = data => {
    return ajax.post('goBuy', data)
}
